<section class="league-detail-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions class="league-detail-meta" *ngIf="league">
      <span>Status: {{ league.status_display || league.status }}</span>
      <span>Reward total: {{ league.total_reward | number : '1.0-0' }}</span>
    </div>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>
  <div class="admin-feedback admin-feedback--success" *ngIf="feedbackSuccess">
    {{ feedbackSuccess }}
  </div>

  <div class="league-overview admin-surface" *ngIf="league">
    <div><strong>Public ID:</strong> {{ league.public_id }}</div>
    <div><strong>Owner:</strong> {{ league.owner?.username || league.owner_id }}</div>
    <div><strong>Tipo:</strong> {{ league.league_type }}</div>
    <div><strong>Acesso:</strong> {{ league.league_access }}</div>
    <div><strong>Início:</strong> {{ league.starts_at | date : 'dd/MM/yyyy HH:mm' }}</div>
    <div><strong>Fim:</strong> {{ league.ends_at | date : 'dd/MM/yyyy HH:mm' }}</div>
    <div><strong>Rounds:</strong> {{ league.rounds }}</div>
    <div><strong>Duração:</strong> {{ league.round_duration }}h</div>
  </div>

  <div class="league-participants admin-surface">
    <h3>Participantes</h3>
    <div class="league-participants__toolbar">
      <input
        class="admin-input"
        [(ngModel)]="participantSearch"
        placeholder="Buscar por username/email"
        (keydown.enter)="filterParticipants()" />
      <button class="admin-btn admin-btn--secondary" (click)="filterParticipants()">Buscar</button>
      <input
        class="admin-input"
        type="number"
        [(ngModel)]="participantIdToAdd"
        placeholder="ID do usuário para adicionar" />
      <button class="admin-btn admin-btn--primary" (click)="addParticipant()">Adicionar</button>
    </div>

    <p-table
      [value]="participants"
      [paginator]="true"
      [rows]="participantsPageSize"
      [totalRecords]="participantsTotal"
      [lazy]="true"
      [loading]="isLoadingParticipants"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th>Player ID</th>
          <th>Username</th>
          <th>Email</th>
          <th>Score</th>
          <th>Boosts pagos</th>
          <th>Check-in</th>
          <th>Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-participant>
        <ng-container>
          <tr [class.league-participants__row--expanded]="isParticipantExpanded(participant.player_id)">
            <td>{{ participant.player_id }}</td>
            <td>{{ participant.username }}</td>
            <td>{{ participant.email }}</td>
            <td>{{ participant.score | number : '1.2-2' }}</td>
            <td>{{ participant.paid_boosts_bought }}</td>
            <td>{{ participant.has_checked_in ? 'Sim' : 'Não' }}</td>
            <td>
              <div class="league-participants__actions">
                <button class="admin-btn admin-btn--secondary" (click)="toggleParticipantDetail(participant.player_id)">
                  {{ isParticipantExpanded(participant.player_id) ? 'Ocultar partidas' : 'Ver partidas' }}
                </button>
                <button class="admin-btn admin-btn--danger" (click)="removeParticipant(participant.player_id)">
                  Remover
                </button>
              </div>
            </td>
          </tr>

          <tr class="participant-expand-row" *ngIf="isParticipantExpanded(participant.player_id)">
            <td colspan="7">
              <div class="participant-inline-detail">
                <p *ngIf="isParticipantDetailLoading(participant.player_id)">Carregando partidas...</p>
                <p class="admin-feedback admin-feedback--error" *ngIf="!isParticipantDetailLoading(participant.player_id) && getParticipantDetailError(participant.player_id)">
                  {{ getParticipantDetailError(participant.player_id) }}
                </p>

                <ng-container *ngIf="!isParticipantDetailLoading(participant.player_id) && getParticipantDetail(participant.player_id) as detail">
                  <p>
                    Score total: {{ detail.total_score | number : '1.2-2' }} | Boosts comprados:
                    {{ detail.participant.paid_boosts_bought }}
                  </p>

                  <div class="participant-round" *ngFor="let round of detail.rounds">
                    <h4>Round #{{ round.round_id }} ({{ round.starts_at | date : 'dd/MM HH:mm' }} - {{ round.ends_at | date : 'dd/MM HH:mm' }})</h4>
                    <p>Round score: {{ round.round_score | number : '1.2-2' }}</p>
                    <p>
                      Boosts:
                      <span *ngIf="round.boosts.length === 0">Nenhum</span>
                      <span *ngFor="let boost of round.boosts">
                        {{ boost.attribute }} (+{{ boost.boost }}) [{{ boost.cost }}]
                      </span>
                    </p>

                    <ng-container *ngIf="getSortedRoundMatches(round) as sortedMatches">
                      <div class="participant-metrics-table-wrapper">
                        <table class="participant-metrics-table">
                          <thead>
                            <tr>
                              <th class="metric-name-column">Métrica</th>
                              <th *ngFor="let match of sortedMatches; let index = index">Partida {{ index + 1 }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let metric of matchMetrics">
                              <td class="metric-name-column">{{ metric.label }}</td>
                              <td *ngFor="let match of sortedMatches">
                                {{ getMatchMetricValue(match, metric.key) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
</section>
